module.exports = __webpack_public_path__ + "static/energy_7-b520063dc941dab06645b0dfb27fceb1.jpg";